// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Config } from "../config";
import { MyReports, ReportRequest, UserParticipantList } from "./types/groupReportTypes";

const apiManagementRootUrl: string | undefined = Config.REACT_APP_CCL_API_MANAGEMENT_URL;

// Define a service using a base URL and expected endpoints
export const cclTokenedGroupReportsApi = createApi({
    reducerPath: "cclTokenedGroupReporGroupReportsApi",
    tagTypes: ["myReports"],
    baseQuery: fetchBaseQuery({
        baseUrl: apiManagementRootUrl,
        prepareHeaders: (headers, { getState }) => {
            //we should probably change this.
            const token = localStorage.getItem("token") as string;
            headers.set("authorization", `Bearer ${token}`);
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getCurrentUserLists: builder.query<UserParticipantList[], string>({
            query: (username) => `group-report-api/v1.0/GroupReport/UserCreatedList/${username}`,
            providesTags: ["myReports"],
        }),
        getCurrentUserCreatedReports: builder.query<MyReports[], ReportRequest>({
            query: (request) =>
                `group-report-api/v1.0/GroupReport/UserCreatedReports/${request.username}/${request.archived}`,
            providesTags: ["myReports"],
        }),
        archiveOrUnArchiveReport: builder.mutation<void, any>({
            query: (request) => ({
                url: `group-report-api/v1.0/GroupReport/GroupReportArchiveOrUnArchive/${request.isArchived}`,
                method: "POST",
                body: request.body,
            }),
            invalidatesTags: ["myReports"],
        }),
        deleteList: builder.mutation<void, any>({
            query: (listId) => ({
                url: `group-report-api/v1.0/GroupReport/DeleteUserCreatedList`,
                body: listId,
                method: "DELETE",
            }),
            invalidatesTags: ["myReports"],
        }),
        copyList: builder.mutation<void, any>({
            query: (copyListRequest) => ({
                url: `group-report-api/v1.0/GroupReport/UserListCopy`,
                body: copyListRequest,
                method: "POST",
            }),
            invalidatesTags: ["myReports"],
        }),
        downloadGroupReport: builder.mutation<any, any>({
            query: (payload) => ({
                url: `group-report-api/v1.0/GroupReport/DownloadReportFile/${payload.filePath}`,
                method: "PUT",
                body: payload.body,
            }),
        }),
        createNewList: builder.mutation<void, UserParticipantList>({
            query: (newListRequest) => ({
                url: `group-report-api/v1.0/GroupReport/NewUserCreatedList`,
                body: newListRequest,
                method: "POST",
            }),
            invalidatesTags: ["myReports"],
        }),
    }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetCurrentUserListsQuery,
    useGetCurrentUserCreatedReportsQuery,
    useArchiveOrUnArchiveReportMutation,
    useDeleteListMutation,
    useCopyListMutation,
    useDownloadGroupReportMutation,
    useCreateNewListMutation,
} = cclTokenedGroupReportsApi;
